import { Link, Stack } from '@mui/material'

import type { FC, ReactNode } from 'react'
import type { PortableTextTypeComponentProps } from '@portabletext/react'
import type { CookieConsentRenewLink } from '@/gen/sanity/schema'

interface SanityCookieConsentLinkProps {
  portableTextImageProps: PortableTextTypeComponentProps<CookieConsentRenewLink>
  linkIcon?: ReactNode
}

export const SanityCookieConsentLink: FC<SanityCookieConsentLinkProps> = ({ portableTextImageProps, linkIcon }) => {
  const cookieConsent = portableTextImageProps.value
  const linkName = cookieConsent?.linkName
  const handleClick = () => {
    if (typeof window.Cookiebot !== 'undefined') {
      window.Cookiebot.renew()
    }
  }

  return (
    <Stack component="span" direction="row" spacing={1} alignItems="center">
      {linkIcon}
      <Link sx={{ cursor: 'pointer' }} onClick={() => handleClick()}>
        {linkName}
      </Link>
    </Stack>
  )
}
